import {
	PLUMAA_USER_FIRST_ACCESS_KEY,
	PLUMAA_USER_SIGNUP_CONTEXT_KEY,
	PLUMAA_USER_SITE_TUTORIAL_PENDING_KEY,
} from '@/constants/session';

export const markUserFirstAccess = () => {
	if (typeof window === 'undefined') return;
	localStorage.setItem(PLUMAA_USER_FIRST_ACCESS_KEY, '1');
	localStorage.setItem(PLUMAA_USER_SIGNUP_CONTEXT_KEY, '1');
};

export const hasUserFirstAccess = () => {
	if (typeof window === 'undefined') return false;
	return localStorage.getItem(PLUMAA_USER_FIRST_ACCESS_KEY) === '1';
};

export const hasUserSignupContext = () => {
	if (typeof window === 'undefined') return false;
	return localStorage.getItem(PLUMAA_USER_SIGNUP_CONTEXT_KEY) === '1';
};

export const clearUserSignupContext = () => {
	if (typeof window === 'undefined') return;
	localStorage.removeItem(PLUMAA_USER_SIGNUP_CONTEXT_KEY);
};

/**
 * Fases do tour só em memória (UserLayout); `localStorage` guarda só se o tour
 * ainda precisa rodar (valor `'1'` ou legado).
 */
export type SiteTutorialPhase =
	| 'welcome'
	| 'sidebar'
	| 'sidebar_nav'
	| 'home_next'
	| 'home_schedule'
	| 'home_filters_tab'
	| 'home_filters_options'
	| 'profile'
	| 'ipbe'
	| 'clubs';

export const markSiteTutorialPending = () => {
	if (typeof window === 'undefined') return;
	localStorage.setItem(PLUMAA_USER_SITE_TUTORIAL_PENDING_KEY, '1');
};

/** Qualquer valor salvo nessa chave indica que o tour completo deve rodar (fases em React). */
export const hasSiteTutorialPending = () => {
	if (typeof window === 'undefined') return false;
	return localStorage.getItem(PLUMAA_USER_SITE_TUTORIAL_PENDING_KEY) !== null;
};

export const clearSiteTutorialPending = () => {
	if (typeof window === 'undefined') return;
	localStorage.removeItem(PLUMAA_USER_SITE_TUTORIAL_PENDING_KEY);
};

/** Removes the welcome-screen flag and marks that the site tutorial should run next. */
export const clearUserFirstAccess = () => {
	if (typeof window === 'undefined') return;
	localStorage.removeItem(PLUMAA_USER_FIRST_ACCESS_KEY);
	if (hasUserSignupContext()) {
		markSiteTutorialPending();
	}
};
